import React from 'react'
import { TextMediumSM } from '../../../../Components/Text/MediumText';
import Temp from './Temp';
import TypeTemp from './TypeTemp';


function TempSettingsIndex() {
  return (
    <div className=' w-full overflow-y-auto'>
        <TextMediumSM content="Temp" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center'>
        <div className=' w-full md:w-1/2 lg:w-1/3'>
            <Temp/>
        </div>
        <div className=' w-full md:w-1/2 lg:w-1/3'>
            <TypeTemp/>
        </div>
        
        </div>
    </div>
  )
}

export default TempSettingsIndex;